<div class="header header-bg {{isLoggedIn ? '' : 'header-hidden'}}">
  <div class="nav-container">
    <div class="menu-button">
      <span class="k-icon hamburger-icon" (click)="onButtonClick()"></span>
    </div>

    <div class="title">
      <h1>World Top Docs</h1>
      <span class="vl"></span>
      <h2>{{ selectedPage }}</h2>
    </div>

    <div class="settings">
      <button
        kendoButton
        [primary]="true"
        class="sign-out-btn"
        (click)="signOut()"
      >
        Sign Out
      </button>
    </div>

    <kendo-avatar
      imageSrc="{{ profileImage != null && profileImage != '' ? profileImage : blankProfileImage }}"
      shape="circle"
      class="d-none d-md-block"
    >
    </kendo-avatar>
  </div>
</div>
